<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm" inline>
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                                 type="select" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button power="b_statistic_stationed_export" @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">
        <c-table-column
            label="商家"
            name="stationed_name"
        >
        </c-table-column>
				<c-table-column
					label="订单数"
					name="order_count"
				>
				</c-table-column>
				
<!--				<c-table-column-->
<!--					label="销量"-->
<!--					name="sales_quantity"-->
<!--				>-->
<!--				</c-table-column>-->
				
				<c-table-column
					label="交易总额"
					name="sales_amount"
				>
					<template v-slot="{data}">
						￥{{data.sales_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="支付人数"
					name="pay_user_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="取消单数"
					name="cancel_order_count"
				>
				</c-table-column>

<!--				<c-table-column-->
<!--					label="取消数量"-->
<!--					name="cancel_quantity"-->
<!--				>-->
<!--				</c-table-column>-->

				<c-table-column
					label="取消总额"
					name="cancel_amount"
				>
					<template v-slot="{data}">
						￥{{data.cancel_amount}}
					</template>
				</c-table-column>

<!--				<c-table-column-->
<!--					label="退款数量"-->
<!--					name="refund_quantity"-->
<!--				>-->
<!--				</c-table-column>-->

				<c-table-column
					label="退款总额"
					name="refund_amount"
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>
        <c-table-column
            label="纠纷退款总额"
            name="dispute_refund_amount"
        >
          <template v-slot="{data}">
            ￥{{data.dispute_refund_amount}}
          </template>
        </c-table-column>

				<!-- <c-table-column
					label="退货数量"
					name="return_quantity"
				>
				</c-table-column>

				<c-table-column
					label="退货总额"
					name="return_amount"
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column> -->

			</c-table>
		</module>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	
	export default {
		name: 'm_statistic_stationed',
		data() {
			return {
                operationMode: [
                    {name: '平台自营',value: 1},
                    {name: '商家自营',value: 2}
                ]
			}
		},
		
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		
		mounted() {
      // 设置默认时间为最近7天
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);

      this.$refs.searchForm.set({
        start_date: this.formatDate(startDate),
        end_date: this.formatDate(endDate)
      });
			this.$refs.search.search();
		},
		
		methods: {
      formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/statistic/stationed/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.searchForm.serialize();
				exportData.job_id = 39;
				exportData.create_system = 'OMS';
        exportData.stationed_type = 1;
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>